import { render } from "./commentsContainer.vue?vue&type=template&id=1b2654e2&scoped=true&ts=true"
import script from "./commentsContainer.vue?vue&type=script&lang=ts"
export * from "./commentsContainer.vue?vue&type=script&lang=ts"

import "./commentsContainer.vue?vue&type=style&index=0&id=1b2654e2&scoped=true&lang=css"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2654e2"]])

export default __exports__